import { createContext } from "react";
import EmployeesContextInterface from "./types";

const EmployeesContext = createContext<EmployeesContextInterface>({
  isLoading: false,
  employees: [],
  employeesNotRemoved: [],
  setEmployees: () => {},
  loadEmployees: () => {},
  setIsLoading: () => {},
});

export default EmployeesContext;
